// TODO: this is unnecessarily complex and should be simplified
export const isFirefox = () => {
  if (navigator.userAgentData) {
    // Check directly for "Safari" in brands
    return navigator?.userAgent.toLowerCase().includes('firefox');
  } else {
    // Fallback for older browsers
    return (
      navigator.userAgent.includes('Firefox') &&
      !navigator.userAgent.includes('Chrome') &&
      !navigator.userAgent.includes('Chromium')
    );
  }
};

export const getUserTimezone = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return undefined;
  }
};

/**
 * True when an automated browser (Happo capture, Playwright/Selenium) is
 * rendering the page. Use it to freeze non-deterministic animations so
 * visual-regression snapshots stay stable. Happo applies `prefers-reduced-motion`
 * via CSS only, so `useReducedMotion()` can't detect it — we check Happo's
 * injected `__IS_HAPPO_RUN` global and `navigator.webdriver` instead.
 */
export const isAutomatedBrowser = (): boolean => {
  if (typeof navigator !== 'undefined' && navigator.webdriver) {
    return true;
  }

  type HappoGlobal = {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Happo's global name
    __IS_HAPPO_RUN?: boolean;
  };

  return Boolean((globalThis as HappoGlobal).__IS_HAPPO_RUN);
};
